import { Button, Card, Col, DatePicker, Form, Input, InputNumber, message, Modal, Row, Select, Upload } from "antd";
import { CustomBtn } from "../../../../components/commonComponents";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { editDocument, getDocLastNumber, uploadDocument } from "../actions";
import { useAppContext } from "../../../../hooks/useAppContext";
import './style.css'

export default function DocumentUploadModal({ open, close, departments, hierarchies, doc, setDocToEdit, messageApi }) {
    const [form] = Form.useForm()
    const [fileList, setFileList] = useState([])
    const { refreshDocs } = useAppContext()

    

    const closeModal = () => {
        close(false)
        form.resetFields()
        setFileList([])
        if (doc) {
            setDocToEdit(null)
        }
    }

    const onFinish = async (values) => {
        if (doc) {
            editDocument(values, doc.id).then(() => {
                closeModal()
                refreshDocs()
                messageApi.success('ინფორმაცია დოკუმენტზე წარმატებით შეიცვალა')
            }).catch((error) => {
                console.log(error)
                messageApi.error(error.message)
            })
        } else {
            if (!values?.library_doc?.fileList[0]?.status) {
                const formData = new FormData()
                formData.append('library_doc', fileList[0])
                formData.append('data', JSON.stringify(values))

                uploadDocument(formData).then(() => {
                    refreshDocs()
                    closeModal()
                    messageApi.success('დოკუმენტი წარმატებით დაემატა')
                }).catch((error) => {
                    console.log('errr',error)
                    messageApi.error(error.message)
                })
            }
        }
    }

    useEffect(() => {
        if (doc) {
            form.setFieldsValue(doc)
        }
    }, [doc])


    const onValuesChange = (changedFields, allFields) => {
        const { department, hierarchy } = allFields
        if (!doc && (!!changedFields.department || !!changedFields.hierarchy) && department && hierarchy) {
            getDocLastNumber(department, hierarchy).then((res) => {
                form.setFieldsValue({
                    number: (res.max || 0) + 1
                })
            })
        }
    }


    const fileprops = {
        name: 'file',
        multiple: false,
        showUploadList: {
            showDownloadIcon: false,
        },
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            setFileList([file]);
            return false;
        },
        fileList,
    };

    return (
        <Modal
            title={doc ? 'დოკუმენტის რედაქტირება' : 'დოკუმენტის დამატება'}
            open={open}
            onCancel={closeModal}
            footer={[
                <CustomBtn key='submit' label='დამატება' onClick={form.submit} color='green' icon={<i className="fa-solid fa-circle-plus"></i>} colorHover='#135200' htmlType="submit" />,
                <CustomBtn key='cancel' label='დახურვა' onClick={closeModal} color='red' icon={<i className="fa-solid fa-xmark"></i>} colorHover='#8c1a1a' />
            ]}
            width={800}
            destroyOnClose={true}
            
        >
            <Card>
                <Form
                    form={form}
                    layout='vertical'
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    onFinish={onFinish}
                    onValuesChange={onValuesChange}
                >
                    <Row justify='center' gutter={[10, 0]}>
                        <Col xs={24} md={12}>
                            <Form.Item
                                label='დეპარტამენტი'
                                name='department'
                                rules={[{ required: true, message: 'დეპარტამენტის აირჩევა სავალდებულოა' }]}
                            >
                                <Select options={departments} showSearch optionFilterProp='label' />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item
                                label='იერარქია'
                                name='hierarchy'
                                rules={[{ required: true, message: 'იერარქიის აირჩევა სავალდებულოა' }]}
                            >
                                <Select options={hierarchies} showSearch optionFilterProp='label' />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={4}>
                            <Form.Item
                                label='ნომერი'
                                name='number'
                                rules={[{ required: true, message: 'ნომერის აირჩევა სავალდებულოა' }]}
                            >
                                <InputNumber style={{ width: '100%' }} min={1} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={4}>
                            <Form.Item
                                label='სუფიქსი'
                                name='number_suffix'
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={16}>
                            <Form.Item
                                label='დოკუმენტის სახელი'
                                name='name'
                                rules={[{ required: true, message: 'დოკუმენტის სახელის აირჩევა სავალდებულოა' }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label='დამტკიცების თარიღი'
                                name='date'
                                initialValue={dayjs()}
                                rules={[{ required: true, message: 'დამტკიცების თარიღის აირჩევა სავალდებულოა' }]}
                            >
                                <DatePicker style={{ width: '100%' }} format='DD.MM.YYYY' />
                            </Form.Item>
                        </Col>
                        {
                            !doc &&
                            <Col span={12} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Form.Item
                                    label='ფაილი'
                                    name='library_doc'
                                    rules={[{ required: true, message: 'დოკუმენტის ფაილის აირჩევა სავალდებულოა' }]}
                                >
                                    <Upload
                                        {...fileprops}
                                        maxCount={1}
                                        accept=".pdf,.docx,.doc,.xls,.xlsx"
                                        customRequest
                                    >
                                        <Button icon={<i className="fa-solid fa-upload"></i>} style={{ width: '100%' }}>
                                            ატვირთვა
                                        </Button>
                                    </Upload>
                                </Form.Item>
                            </Col>
                        }
                        <Col span={24}>
                            <Form.Item
                                label='დოკუმენტის აღწერა'
                                name='description'
                            >
                                <Input.TextArea rows={4} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </Modal>
    )
}